import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import Select from "react-select";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import { GlobalContext } from "../../../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../../component/form/form-layout";

const AddActivityModal = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  CustomerData = {},
  UsersList = [],
  // entityData = [],
  id,
  entitytype,
  entityname,
  Style,
}) => {
  let { state } = useContext(GlobalContext);

  const priorityArray = [
    {
      value: "low",
      label: "Low",
    },
    {
      value: "medium",
      label: "Medium",
    },
    {
      value: "high",
      label: "High",
    },
  ];

  const statusArray = [
    {
      value: "pending",
      label: "Pending",
    },
    // {
    //   value: "overdue",
    //   label: "Overdue",
    // },
    {
      value: "completed",
      label: "Completed",
    },
  ];

  const userOptions = UsersList?.map((agents) => ({
    value: agents.userid,
    label: agents.name,
  }));

  const priorityOptions = priorityArray?.map((pr) => ({
    value: pr.value,
    label: pr.label,
  }));

  const statusOptions = statusArray?.map((pr) => ({
    value: pr.value,
    label: pr.label,
  }));

  const [showSuggestions, setShowSuggestions] = useState(false);

  const suggestionList = [
    "Call",
    "Meeting",
    "Email",
    "Follow-up",
    "Demo",
    "Chat",
    "Consultation",
    "Presentation",
  ];

  const formattedSuggestions = suggestionList?.map((item) => ({
    value: item,
    label: item,
  }));

  const apiCall = useApiCall();

  const [entityData, setEntityData] = useState([]);

  const fetchEntities = async (search = "") => {
    try {
      const res = await apiCall({
        method: "get",
        url: `activities/get-activity-type?search=${encodeURIComponent(
          search,
        )}`,
      });

      const list = res?.data || []; // 👈 safe access to data array

      setEntityData(
        list.map((item) => ({
          id: item.id,
          name: item.name,
          type: item.type,
        })),
      );
    } catch (error) {
      console.error("Error fetching entities:", error);
    }
  };

  useEffect(() => {
    fetchEntities();
  }, []);

  let editEntType = "";
  let editEntId = "";

  useEffect(() => {
    console.log("CustomerData", CustomerData);
    console.log("id", id);
    console.log("entitytype", entitytype);
    console.log("entityname", entityname);
    if (CustomerData && Object.keys(CustomerData).length > 0) {
      // Edit mode
      const selectedEntity = CustomerData.entity_id
        ? {
            id: CustomerData.entity_id,
            label: `${CustomerData.entity?.name} (${CustomerData.entity_type})`,
            type: CustomerData.entity_type,
          }
        : null;

      formik.setValues({
        type: CustomerData.type || "",
        due_date: CustomerData.due_date
          ? moment(CustomerData.due_date).format("YYYY-MM-DD")
          : "",
        due_time: CustomerData.due_time
          ? moment(CustomerData.due_time, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
          : "",
        priority: CustomerData.priority || "",
        status: CustomerData.status || "",
        entity: selectedEntity,
        assigned: CustomerData?.assignee?.userid || "",
        notes: CustomerData.note || "",
      });
    } else {
      // Add mode

      if (id && entitytype) {
        const selectedEntity = {
          id: id,
          label: `${entityname} (${entitytype})`,
          type: entitytype,
        };

        formik.setFieldValue("entity", selectedEntity);
      } else {
        formik.resetForm();
      }

      editEntId = CustomerData?.entity_id || "";
      editEntType = CustomerData?.entity_type || "";
    }
  }, [CustomerData]);

  const [entityType, setEntityType] = useState("");

  const validationSchema = yup.object({
    type: yup.string().required("This Field is Required"),
    due_date: yup.string().required("This Field is Required"),
    due_time: yup.string().required("This Field is Required"),
    priority: yup.string().required("This Field is Required"),
    // status: yup.string().required("This Field is Required"),
    entity: yup.mixed().required("This Field is Required"),
    assigned: yup.string().required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      type: "",
      due_date: "",
      due_time: "",
      priority: "",
      status: "",
      entity: null,
      assigned: "",
      notes: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const isEdit = !!CustomerData?.id;

      // const entity_id = CustomerData?.entity_id;
      // const entity_type = CustomerData?.entity_type;

      const userId = state?.user?.userid;

      const data = {
        // entity_id: values.entity?.value || "",
        // entity_type: values.entity?.type || "",
        entity_id: values.entity?.id || editEntId,
        entity_type: values.entity?.type || editEntType,
        assigned_to: formik.values.assigned || "",
        type: formik.values.type,
        subject: formik.values.subject || "Activity",
        note: formik.values.notes,
        due_date: formik.values.due_date,
        due_time: formik.values.due_time,
        priority: formik.values.priority,
        status: isEdit ? formik.values.status : "pending",
      };

      console.log("values", values);
      console.log("Entity data", data);

      try {
        const apiRes = await apiCall({
          method: "post",
          url: isEdit
            ? `activities/update-activity/${CustomerData?.id}`
            : "activities/add-activity",
          data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message || "Request Submitted");
        onClose();
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      }
    },
  });

  const [activeIndex, setActiveIndex] = useState(0);

  const filteredSuggestions = suggestionList?.filter((item) =>
    item.toLowerCase().includes(formik.values.type.toLowerCase()),
  );

  const handleKeyDown = (e) => {
    if (!showSuggestions || filteredSuggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev + 1 >= filteredSuggestions.length ? 0 : prev + 1,
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev - 1 < 0 ? filteredSuggestions.length - 1 : prev - 1,
      );
    }

    if (e.key === "Enter") {
      e.preventDefault();
      formik.setFieldValue("type", filteredSuggestions[activeIndex]);
      setShowSuggestions(false);
    }

    if (e.key === "Escape") {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    if (showSuggestions) setActiveIndex(0);
  }, [showSuggestions]);

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        <div className={Style.modal_body}>
          <FormArea>
            {/* type */}

            <FeildWraper width="100%">
              <FormLabel required>Type</FormLabel>

              {/* <div className="relative">
                <input
                  type="text"
                  name="type"
                  value={formik.values.type}
                  onChange={(e) => {
                    formik.setFieldValue("type", e.target.value);
                    setShowSuggestions(true);
                  }}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() =>
                    setTimeout(() => setShowSuggestions(false), 200)
                  }
                  onKeyDown={handleKeyDown}
                  placeholder="Type activity (e.g. Call, Meeting...)"
                  autoComplete="off"
                />

                {showSuggestions &&
                  formik.values.type &&
                  filteredSuggestions.length > 0 && (
                    <ul
                      className="absolute left-0 right-0 bg-white border border-gray-200 rounded-md mt-1 max-h-40 overflow-y-auto shadow-lg z-[999]"
                      style={{ listStyle: "none", padding: 0, margin: 0 }}
                    >
                      {filteredSuggestions.map((suggestion, i) => (
                        <li
                          key={i}
                          onMouseDown={() => {
                            formik.setFieldValue("type", suggestion);
                            setShowSuggestions(false);
                          }}
                          className={`px-3 py-2 cursor-pointer text-sm transition-colors ${i === activeIndex
                              ? "bg-blue-100"
                              : "hover:bg-blue-50"
                            }`}
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
              </div> */}

              <SelectSearch
                name="type"
                placeholder={"- Select Activity -"}
                onChange={(val) => {
                  formik.setFieldValue("type", val ? val : "");
                }}
                value={formik?.values.type}
                options={formattedSuggestions}
                onBlur={() => formik.setFieldTouched("type", true, true)}
                menuPosition="fixed"
              />
              {formik.touched.type && formik.errors.type && (
                <FeildError>{formik.errors.type}</FeildError>
              )}
            </FeildWraper>

            {/* Due Date */}
            <FeildWraper>
              <FormLabel required>Due Date</FormLabel>
              <input
                type="date"
                name="due_date"
                min={
                  !CustomerData?.id
                    ? new Date().toISOString().split("T")[0]
                    : null
                }
                value={formik.values.due_date}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Due Date"
              />
              {formik.touched.due_date && formik.errors.due_date && (
                <FeildError>{formik.errors.due_date}</FeildError>
              )}
            </FeildWraper>

            {/* Due Time */}

            <FeildWraper>
              <FormLabel required>Due Time</FormLabel>
              <input
                type="time"
                name="due_time"
                value={formik.values.due_time}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Due Time"
              />
              {formik.touched.due_time && formik.errors.due_time && (
                <FeildError>{formik.errors.due_time}</FeildError>
              )}
            </FeildWraper>

            {/* Priority */}

            <FeildWraper>
              <FormLabel required>Priority</FormLabel>

              <SelectSearch
                name="priority"
                placeholder={"- Select Priority -"}
                onChange={(val) => {
                  formik.setFieldValue("priority", val ? val : "");
                }}
                value={formik?.values.priority}
                options={priorityOptions}
                onBlur={() => formik.setFieldTouched("priority", true, true)}
                menuPosition="fixed"
              />
              {formik.touched.priority && formik.errors.priority && (
                <FeildError>{formik.errors.priority}</FeildError>
              )}
            </FeildWraper>

            {/* Status */}
            {/* <FeildWraper>
              <FormLabel required>Status</FormLabel>

              <SelectSearch
                name="status"
                placeholder={"- Select Status -"}
                onChange={(val) => {
                  formik.setFieldValue("status", val ? val : "");
                }}
                value={formik?.values.status}
                options={statusOptions}
                onBlur={() => formik.setFieldTouched("status", true, true)}
                menuPosition="fixed"
              />
              {formik.touched.status && formik.errors.status && (
                <FeildError>{formik.errors.status}</FeildError>
              )}
            </FeildWraper> */}

            {!CustomerData?.id && !id ? (
              <>
                {/*  project */}
                <FeildWraper>
                  <FormLabel required>Lead Deal or Project</FormLabel>

                  <SelectSearch
                    name="entity"
                    placeholder="- Select Entity -"
                    onChange={(val) => {
                      formik?.setFieldValue("entity", val);
                      console.log("entity value", val);
                    }}
                    value={formik?.values.entity}
                    options={entityData?.map((e) => ({
                      label: `${e.name} (${e.type})`,
                      value: e,
                      type: e.type,
                    }))}
                    onBlur={() => formik.setFieldTouched("entity", true, true)}
                    // menuPosition="fixed"
                  />

                  {formik.touched.entity && formik.errors.entity && (
                    <FeildError>{formik.errors.entity}</FeildError>
                  )}
                </FeildWraper>
              </>
            ) : null}

            {/*  Assigned */}
            <FeildWraper width={CustomerData?.id || id ? "100%" : "100%"}>
              <FormLabel required>Assigned</FormLabel>
              {/* <Select
                name="assigned"
                className="text-sm"
                classNamePrefix="react-select"
                options={userOptions}
                components={{
                  IndicatorSeparator: () => null,
                }}
                // ✅ Only depend on formik value
                value={
                  userOptions.find(
                    (option) => option.value === formik.values.assigned
                  ) || null
                }
                onChange={(selectedOption) => {
                  // ✅ Set only ID
                  formik.setFieldValue("assigned", selectedOption?.value || "");
                }}
                placeholder="Assigned..."
                isClearable
                menuPlacement="auto"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb",
                    boxShadow: state.isFocused ? "0 0 0 1px #none" : "none",
                    "&:hover": { borderColor: "#none" },
                    borderRadius: "0.5rem",
                    minHeight: "40px",
                    fontSize: "0.875rem",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    borderRadius: "0.5rem",
                    padding: "0.25rem 0",
                  }),
                  option: (base, { isFocused, isSelected }) => ({
                    ...base,
                    backgroundColor: isSelected
                      ? "#3b82f6"
                      : isFocused
                      ? "#eff6ff"
                      : "white",
                    color: isSelected ? "white" : "#111827",
                    cursor: "pointer",
                    fontSize: "0.875rem",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#9ca3af",
                  }),
                }}
              /> */}

              <SelectSearch
                name="assigned"
                placeholder="- Select Assigned -"
                onChange={(val) => {
                  formik?.setFieldValue("assigned", val);
                }}
                value={formik?.values.assigned}
                options={userOptions}
                onBlur={() => formik.setFieldTouched("assigned", true, true)}
                // menuPosition="fixed"
              />
              {formik.touched.assigned && formik.errors.assigned && (
                <FeildError>{formik.errors.assigned}</FeildError>
              )}
            </FeildWraper>

            {/* notes */}
            <FeildWraper width="100%">
              <FormLabel>Notes</FormLabel>
              <textarea
                placeholder="write your notes here..."
                name="notes"
                value={formik.values.notes}
                onChange={formik.handleChange}
                className="min-h-28 h-full max-h-52"
              ></textarea>
            </FeildWraper>
          </FormArea>
        </div>

        <div className={Style.modal_foot}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={`${Style.dcmb__submit}`}>
            {CustomerData?.id ? "Save Changes" : "Create Follow Ups"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddActivityModal;
